import { RouteRecordRaw } from 'vue-router'

export const channelsRoutes: RouteRecordRaw[] = [
  {
    path: '/channels',
    name: 'channels',
    redirect: () => {
      return { path: '/pillars' }
    }
  },
  {
    path: '/channels/dashboard',
    name: 'channelsDashboard',
    component: () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/views/channel/ChannelsDashboard.vue'
      ),
    meta: {
      title: 'Channels Dashboard',
      onlyLoggedIn: true
    }
  },
  {
    path: '/channels/cx_dashboard',
    name: 'channelsCxDashboard',
    component: () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/views/channel/ChannelsCxDashboard.vue'
      ),
    meta: {
      title: 'Channels Cx Dashboard',
      onlyLoggedIn: true
    }
  },
  {
    path: '/debug/channels',
    name: 'Debug channels',
    component: () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/views/channel/DebugChannels.vue'
      ),
    meta: {
      title: 'Debug Channels',
      onlyLoggedIn: true
    }
  },
  {
    path: '/channels/:channelId/videocall',
    name: 'VideoCall',
    component: () =>
      import(
        /* webpackChunkName: "pillars" */
        '@/views/channel/VideoCall.vue'
      ),
    meta: {
      plainLayout: true,
      onlyLoggedIn: true
    }
  }
]
